module.exports = {
  BASELINE_WEIGHT: 'baseline_weight',
  HIGHEST_WEIGHT: 'highest_weight',
};
